export const GrowthPredictionModalView = Object.freeze({
  GROWTH_PREDICTION_CHOICE: 'growth_prediction_choice',
  GROWTH_PREDICTION_GROUP: 'growth_prediction_group',
  GROWTH_PREDICTION_PERSON: 'growth_prediction_sporter',
  GROWTH_PREDICTION_SESSION: 'growth_prediction_session'
});
